module.exports = __webpack_public_path__ + "static/bonaire logo-bfff9b9749f4a82f056a6ff1afd50b00.png";